
import GeoJSON from 'ol/format/GeoJSON';
import { getAccessToken } from 'client/utils/auth/msalHelpers';
import { apiBaseUrl } from 'client/utils/constants/frontEndConfig';
import { normaliseDimensionFeature } from './customVectorHelpers';
import { PREFIX_NETWORK } from './constants';

export const loadFeatures = async (params, callbackSuccess, callbackFailure) => {
    const getString = new URLSearchParams(params).toString();
    const typeName = params.typeName.replace(PREFIX_NETWORK, '');
    const accessToken = await getAccessToken();

    return fetch(`${apiBaseUrl}/nuar-vector-data/ows/?${getString}`, {
        method: 'GET',
        headers: { Authorization: accessToken }
    }).then(responsePromise => {
        return responsePromise.json();
    }).then(featureCollection => {
        const features = new GeoJSON().readFeatures(featureCollection).map(normaliseDimensionFeature);
        callbackSuccess(features, typeName);
    }).catch((err) => {
        callbackFailure(err, typeName);
    });
};
